import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useContext } from 'react';
import AuthContext from '../../contexts/authentication/AuthProvider';
import {
  MinimumPermission,
  PermissionLevel,
} from '../../types/claims/profilePermission';
import { SystemModules } from '../../types/claims/userManagerModules';
import { selectPermissions } from '../../utils/selectPermissions';

interface RequireAuthProps {
  moduleClaim?: SystemModules;
  minimumPermission?: MinimumPermission;
}
const RequireAuth = ({ minimumPermission, moduleClaim }: RequireAuthProps) => {
  const location = useLocation();
  const { user } = useContext(AuthContext);
  const permissionsRequired: PermissionLevel[] | undefined =
    selectPermissions(minimumPermission);

  let permission = false;
  if (permissionsRequired && moduleClaim !== undefined && user?.claims) {
    permission = permissionsRequired.includes(user.claims[moduleClaim]);
  }

  if (!permission) {
    return (
      <Navigate
        to="/401"
        state={{ from: location }}
        replace
      />
    );
  }

  return <Outlet />;
};

export default RequireAuth;
